import type { AuditAction } from '@raptor/shared';

export type { AuditAction };

export interface AuditLogEntry {
  id: string;
  customerId: string | null;
  adminId: string | null;
  action: AuditAction;
  resourceType: string;
  resourceId: string | null;
  ipAddress: string;
  userAgent: string;
  metadata: Record<string, unknown>;
  createdAt: string;
}

export interface AuditLogFilters {
  customerId?: string;
  action?: AuditAction;
  dateFrom?: string;
  dateTo?: string;
  limit?: number;
  offset?: number;
}

export interface AuditLogResponse {
  items: AuditLogEntry[];
  total: number;
}

export const AUDIT_ACTION_VALUES: readonly AuditAction[] = [
  'login',
  'logout',
  'upload.create',
  'upload.download',
  'upload.delete',
  'issue.create',
  'issue.view',
  'issue.comment',
  'release.download',
  'account.create',
  'account.deactivate',
  'account.password_reset',
] as const;
